import ListFields from '../fragments/ListFields';

export default (languageCode: string) => /* GraphQL */ `
    mutation AddItems($items: [AddItemInput!]!, $listId: ID) {
        list: addItems(
            items: $items
            listId: $listId
            itemPresentation: { languageCode: "${languageCode}" }
        ) {
            ...ListFields
        }
    }
    ${ListFields}
`;
